import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Button, Modal, Header, Icon, Message } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';
// import JsBarcode from 'jsbarcode';
// import { saveAs } from 'file-saver';
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

import codBarras from '../../../functions/codbarras'

// "use strict";

class FactElimONE2 extends React.Component {
  state={argsDocum: {contrato: ""},
    factPdf_envCorr: "", confirmaAct: false, open: false, errors: []}

  handleChange = (ev) => {
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    const argsDocum = this.state.argsDocum
    argsDocum[ev.target.name] = ev.target.value
    this.setState({argsDocum})
    // console.log(this.state.argsDocum)
    this.setState({confirmaAct: false})
  }

  handleSubmit = async (ev, argsDocum)=>{
    console.log("handleSubmit")
    // let archPdf = ev.target.name

    // document.body.style.cursor = 'wait'
    // let errors = []

    //   if(!argsDocum.contrato){
    //     errors.push({path: "Eliminar Cobro", message: "Por favor escriba el contrato"});
    //     archPdf = "nohaydatos"
    //   }

    // this.setState({errors})
    // if(errors.length===0){
    //   if(archPdf!=="nohaydatos"){
    //     let tipoqry = argsDocum.contrato + "|||ELIMINAR UN COBRO EN ONEPAY"

    //     let argsBuscarFact = {tipoqry: tipoqry}
    //     if(argsBuscarFact){
    //       let {data} = await this.props.allClientesRtes.refetch(argsBuscarFact)
    //     }
    //   }
    // }
    // document.body.style.cursor = 'default'
  }

  handleEnvCorreo = async (ev, factPdf_envCorr, argsDocum) => {
    let archPdf = ev.target.name

    if(factPdf_envCorr==="btnElimContr"){
      document.body.style.cursor = 'wait'
      let errors = []

      if(!argsDocum.contrato){
        errors.push({path: "Eliminar Cobro", message: "Por favor escriba el contrato"});
        archPdf = "nohaydatos"
      }

      this.setState({errors})
      if(errors.length===0){
        if(archPdf!=="nohaydatos"){
          let tipoqry = argsDocum.contrato + "|||ELIMINAR UN COBRO EN ONEPAY"

          let argsBuscarFact = {tipoqry: tipoqry}
          if(argsBuscarFact){
            let {data} = await this.props.allClientesRtes.refetch(argsBuscarFact)
            const argsDocum = this.state.argsDocum
            argsDocum["contrato"] = ""
            this.setState({argsDocum})
            let contrato = document.getElementById("contrato");
            contrato.value = ""

          }
        }
      }
      document.body.style.cursor = 'default'
    }

    if(factPdf_envCorr==="btnElimTodo"){
      document.body.style.cursor = 'wait'

      if(archPdf!=="nohaydatos"){
        let tipoqry = "TODOS|||ELIMINAR TODOS LOS COBROS EN ONEPAY"

        let argsBuscarFact = {tipoqry: tipoqry}
        if(argsBuscarFact){
          let {data} = await this.props.allClientesRtes.refetch(argsBuscarFact)
        }
      }
    }
    document.body.style.cursor = 'default'

    this.setState({confirmaAct: false})
    this.setState({open: false})
  }

  handleQuestionUpdDel = async (ev) => {
    if(ev.target.attributes[1].value==="btnElimTodo"||ev.target.attributes[1].value==="btnElimContr"){
      this.setState({factPdf_envCorr: ev.target.attributes[1].value})
    }
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = document.getElementById("btnUpdDel");
        // if(myBtn){
          myBtn.click()
        // }
    }
    if(btnPress==="btnUpdDel"){
      this.setState({confirmaAct: false})
    };
  }

  render(){
    const {argsDocum, factPdf_envCorr, confirmaAct, open, errors} = this.state;

    const a051401 = this.props.autorizacUA.findIndex( autorizac => autorizac === "051401" );
    const a051410 = this.props.autorizacUA.findIndex( autorizac => autorizac === "051410" );

    // console.log(argsDocum)
    let mensaje = "ELIMINAR TODOS LOS COBROS CREADOS EN ONEPAY"
    // console.log(errors.length)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large plus yellow icon"></i>
            Enviar ELIM a ONEPAY
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1">
              <div>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '80%'}}>
                      <h1 style={{color: '#2C7744'}}>Enviar ELIMINACION a ONEPAY</h1>
                    </div>
                  </div>
                </div>
                
                <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Contrato
                        </label>
                        <input style={this.props.styles.input} autoComplete="off" name="contrato" id="contrato" onChange={this.handleChange} placeholder='Contrato'/>
                      </Form.Field>
                    </div>
                  </div>
                </div>

                <hr></hr>
                <Modal open={open} size="tiny" style={this.props.styles.modal} trigger={

                <div className="ui four column stackable grid">
                  <div className="row container">
                    {/* <div className="column" style={{width: '50%'}}>
                      <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum)} fluid>
                          Eliminar contrato {this.state.argsDocum.contrato} en ONEPAY
                      </Button>
                    </div> */}

                    <div className="column" style={{width: '50%'}}>
                      {(a051401!==-1) &&
                        <Button name="btnUpdDel" id="btnElimContr" style={this.props.styles.confirmar} onClick={(ev)=>this.handleQuestionUpdDel(ev)} fluid>
                          Eliminar cobro a contrato {argsDocum.contrato} en ONEPAY
                        </Button>
                      }
                    </div>

                    <div className="column" style={{width: '50%'}}>
                      {(a051410!==-1) &&
                        <Button name="btnUpdDel" id="btnElimTodo" style={this.props.styles.confirmar} onClick={(ev)=>this.handleQuestionUpdDel(ev)} fluid>
                          ELIMINAR TODOS LOS COBROS CREADOS EN ONEPAY
                        </Button>
                      }
                    </div>
                  </div>
                </div>
                }>
                <Header icon='edit' color='red' content={factPdf_envCorr==="btnElimTodo"?`${mensaje}`:`Eliminar cobro a contrato ${argsDocum.contrato} en ONEPAY`} />      
                <Modal.Content>
                  <p>Esta usted seguro ?</p>
                </Modal.Content>
                <Modal.Actions>
                  <Button dato1="No" name='btnNoUpd' color='red' onClick={(ev)=>this.handleQuestionUpdDel(ev)}>
                    <Icon dato1="No" name='remove' /> No
                  </Button>
                  <Button dato1="Si" name='btnSiUpd' color='green' onClick={(ev)=>this.handleEnvCorreo(ev, factPdf_envCorr, argsDocum)}>
                    <Icon dato1="Si" name='checkmark' /> Si
                  </Button>
                </Modal.Actions>
              </Modal>

                <hr></hr>
                        
                {
                    errors.length?<Message negative header="Los siguientes errores:"
                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientesRtes, {name:'allClientesRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: "XXXYYYZZZ"}}]`}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(FactElimONE2)
